module.exports = __webpack_public_path__ + "img/youtube_logo.70f812c5.png";